import { render, staticRenderFns } from "./UrlsMetricsGrid.vue?vue&type=template&id=6f33bb6d&scoped=true&"
import script from "./UrlsMetricsGrid.vue?vue&type=script&lang=js&"
export * from "./UrlsMetricsGrid.vue?vue&type=script&lang=js&"
import style0 from "./UrlsMetricsGrid.vue?vue&type=style&index=0&id=6f33bb6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f33bb6d",
  null
  
)

/* custom blocks */
import block0 from "./UrlsMetricsGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports